export function IconUploadCloud() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 16L12 12M12 12L7.99999 16M12 12V21M20.39 18.39C21.3653 17.8583 22.1358 17.0169 22.5799 15.9986C23.0239 14.9804 23.1162 13.8432 22.8422 12.7667C22.5682 11.6901 21.9435 10.7355 21.0667 10.0534C20.1898 9.37138 19.1109 9.00073 18 9H16.74C16.4373 7.82924 15.8732 6.74233 15.0899 5.82099C14.3067 4.89965 13.3248 4.16785 12.2181 3.68061C11.1113 3.19336 9.90854 2.96336 8.70011 3.00788C7.49167 3.05241 6.30906 3.3703 5.24117 3.93766C4.17328 4.50503 3.2479 5.3071 2.53461 6.28358C1.82132 7.26006 1.33868 8.38554 1.12297 9.57539C0.90726 10.7653 0.964096 11.9885 1.2892 13.1533C1.61431 14.318 2.19923 15.3939 2.99999 16.3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        vectorEffect="non-scaling-size"
      />
    </svg>
  );
}
